import { createApi } from '@reduxjs/toolkit/query/react';
import { uploadFileBaseQuery } from '../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSuccessResponse } from '../../utils/API/responseMiddleware';

const fileUploadApi = createApi({
  reducerPath: 'fileUploadApi',
  baseQuery: uploadFileBaseQuery,
  endpoints: (builder) => ({
    UploadCsvFile: builder.mutation({
      query: (file) => {
        const formData = new FormData();
        formData.append('file', file, file.name);

        return {
          url: '/ClientValuation/UploadCsvFile',
          method: 'POST',
          body: formData,
        };
      },
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),
  }),
});

export const { useUploadCsvFileMutation } = fileUploadApi;

export default fileUploadApi;
